var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('router-view'),_c('app-footer'),_c('transition',{attrs:{"name":"fadevideobox"}},[(_vm.videoCinemaState || _vm.videoCinemaPreviewItem)?_c('app-videoplayer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }